import { render, staticRenderFns } from "./ChangeMailDialog.vue?vue&type=template&id=053772db"
import script from "./ChangeMailDialog.vue?vue&type=script&lang=js"
export * from "./ChangeMailDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports